import type { CSSProperties } from 'react';

/**
 * A marca é um documento com o canto dobrado — a nota fiscal, que é o que
 * o produto guarda — e o "9" da casa i9si no lugar do texto da nota. Em
 * fundo escuro (`tom="sobreAcento"`) tudo vira branco: o mesmo desenho
 * serve nos dois lugares sem uma segunda arte.
 */
export function Logo({
  tamanho = 32,
  tamanhoFonte = 22,
  tom = 'normal',
  soMarca = false,
  style,
}: {
  tamanho?: number;
  tamanhoFonte?: number;
  tom?: 'normal' | 'sobreAcento';
  soMarca?: boolean;
  style?: CSSProperties;
}) {
  const sobre = tom === 'sobreAcento';
  const fundo = sobre ? 'rgba(255,255,255,.16)' : 'var(--accent)';
  const papel = sobre ? '#fff' : '#fff';
  const traco = sobre ? 'rgba(255,255,255,.55)' : 'var(--accent-soft)';

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, ...style }}>
      <svg width={tamanho} height={tamanho} viewBox="0 0 40 40" aria-hidden="true">
        <rect x="0" y="0" width="40" height="40" rx="11" fill={fundo} />
        <path
          d="M11 9.5h11.2L29 16.2V30a1.5 1.5 0 0 1-1.5 1.5h-16A1.5 1.5 0 0 1 10 30V11a1.5 1.5 0 0 1 1-1.5Z"
          fill={papel}
          opacity={sobre ? 0.95 : 1}
        />
        <path d="M22 9.5V15a1.5 1.5 0 0 0 1.5 1.5H29" fill="none" stroke={traco} strokeWidth="1.6" />
        <text
          x="19.5"
          y="27.5"
          textAnchor="middle"
          fontFamily="'Barlow', system-ui, sans-serif"
          fontSize="13"
          fontWeight="800"
          fill={sobre ? '#3d84c6' : 'var(--accent)'}
        >
          9
        </text>
      </svg>

      {!soMarca && (
        <span
          className="wordmark"
          style={{ fontSize: tamanhoFonte, color: sobre ? '#fff' : 'var(--text)' }}
        >
          Conti<span className="dot" style={sobre ? { color: 'rgba(255,255,255,.7)' } : undefined}>9</span>
        </span>
      )}
    </div>
  );
}
